if (!customElements.get('variant-preview-picker')) {
  customElements.define('variant-preview-picker', class VariantPreviewPicker extends HTMLElement {
    previousIndex = 0

    constructor() {
      super()

      // elements
      this.buttons = this.querySelectorAll('button[type="button"]')
      this.images = this.parentElement.querySelectorAll('.variant-base')

      if(this.buttons.length === 0) return

      // listeners
      this.buttons.forEach((b, i) => {
        b.addEventListener('click', this.onButtonClick.bind(this, i))
      })
    }

    onButtonClick(index, event) {
      event.preventDefault()

      this.buttons[this.previousIndex].classList.replace('tw-border-paka-black','tw-border-paka-white')
      this.buttons[this.previousIndex].classList.remove('tw-z-1')
      var prevImage = this.images[this.previousIndex]
      prevImage.classList.replace('tw-opacity-100','tw-opacity-0')
      prevImage.classList.add('tw-hidden') // DD: Prevent image from showing when prevImage is higher in DOM stack
      setTimeout(() => prevImage.classList.remove('tw-hidden'), 300) // DD: Should be same as tw-duration-### value
      var prevImageHover = this.parentElement.querySelector(`.variant-hover[data-variant-index="${prevImage.dataset.variantIndex}"]`)
      prevImageHover?.classList?.add('tw-hidden')

      this.buttons[index].classList.replace('tw-border-paka-white','tw-border-paka-black')
      this.buttons[index].classList.add('tw-z-1')
      var nextImage = this.images[index]
      nextImage.classList.replace('tw-opacity-0','tw-opacity-100')
      var nextImageHover = this.parentElement.querySelector(`.variant-hover[data-variant-index="${nextImage.dataset.variantIndex}"]`)
      nextImageHover?.classList?.remove('tw-hidden')

      this.previousIndex = index
    }
  })
}